<template>
  <transition name="toast-transition">
    <div class="toast__container" v-if="toasts.length" :style="{ maxWidth: `${maxWidth}px` }">
      <transition-group name="toast-transition" tag="div">
        <div v-for="(toast, index) in toasts" :key="`toast${index}`" class="toast__item">
          <header class="toast__header">
            <div class="toast-icon">
                <p4a-icon :icon="toast.icon" :class="toast.class"></p4a-icon>
             </div>
             <div class="toast-title">
               <h1>{{toast.title}}</h1>
             </div>
              <div class="toast-close" @click="removeToast(index)">
                <p4a-icon :icon="'close'"/>
              </div>
          </header>
          <div class="toast__message">
            <pre>{{ toast.message }}<span @click="$emit('toastIssue', toast.callBackIssue)" v-if="toast.callBackIssue">&nbsp;. view issue</span></pre>
          </div>
        </div>
      </transition-group>
    </div>
  </transition>
</template>

<script>

export default {
  props: {
    duration: {
      type: Number,
      default: 5000
    },
    stackSize: {
      type: Number,
      default: 5
    },
    maxWidth: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      toasts: []
    }
  },
  created ()  {
    this.$eventBus.$on('p4aToast', (toastParameters) => { this.show(toastParameters) })
  },
  methods: {
    show (toastParameters) {
      if (toastParameters) {
        const toastStyle = this.getToastStyle(toastParameters.type || 'info')
        const duration = Number(toastParameters.duration) || this.duration
        toastParameters.icon = toastStyle.icon
        toastParameters.class = toastStyle.class
        toastParameters.timeOutId = setTimeout(() => {
          this.toasts = this.toasts.filter(t => t.timeOutId !== toastParameters.timeOutId)
        }, duration)
        if (this.toasts.length === this.stackSize) {
          const toast = this.toasts.shift()
          clearTimeout(toast.timeOutId)
        }
        this.toasts.push(toastParameters)
      }
    },
    getToastStyle(toastType) {
      switch(toastType.toLowerCase()) {
        case 'error':
          return { class: 'state-error', icon: 'state-error'}
        case 'success':
          return { class: 'state-success', icon: 'state-okay'}
        case 'warning':
          return { class: 'state-warning', icon: 'state-warning'}
        case 'info':
          default:
        return { icon: 'info' }
      }
    },
    removeToast (toastIndex) {
      clearTimeout(this.toasts[toastIndex].timeOutId)
      this.toasts.splice(toastIndex, 1);
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../styling/styling.scss';
  .toast {

    &__container {
      z-index: 900;
      left: rem(75);
      position: fixed;
      bottom: rem(25);
    }

    &__item {
      min-height: rem(75);
      min-width: rem(370);
      margin-top: rem(25);
      @extend %shadow-big;
      border-radius: rem(2);
      background-color: white;
    }

    &__header {
      height: rem(50);
      padding: 0;

      .toast-icon, .toast-close {
        width: rem(50);
        height: rem(50);
        float: left;
        padding: rem(17);
        line-height: rem(16);

        > .state-error { color: $error-red; }

        > .state-success { color: $approved-green; }

        > .state-warning { color: $alert-orange; }
      }

      .toast-close {
        float: right;
        cursor: pointer;
        color: $light-grey-font;

        &:hover { color: $medium-grey-font; }
      }

      .toast-title {
        width: calc(100% - #{rem(100)});
        float: left;

        h1 {
          margin: 0;
          padding: 0;
          font-weight: 500;
          font-size: rem(17);
          line-height: rem(50);
          color: $dark-grey-font;
        }
      }
    }

    &__message {
      padding: 0 rem(50);
      min-height: rem(25);
      color: $medium-grey-font;

      pre {
        margin: 0;
        font-weight: 300;
        font-size: rem(13);
        font-family: inherit;
        white-space: pre-wrap;
        padding-bottom: rem(10);
      }

      span {
        cursor: pointer;
        color: $pending-blue;
      }
    }

    &-transition-enter {
      opacity: 0;
      transform: translateY(rem(20));
    }

    &-transition-enter-active { transition: opacity .5s ease-out, transform 1s ease-out; }
  }
  </style>



// WEBPACK FOOTER //
// node_modules/pro4all-ui/ui-kit/components/Toast.vue